import React from 'react'

const ArrowLeft = ({ width = 18, height = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
  >
    <path fill="none" d="M0,0H18V18H0Z" />
    <path
      fill="#f3f5f9"
      d="M14,8.375H6.394L9.887,4.881,9,4,4,9l5,5,.881-.881L6.394,9.625H14Z"
    />
  </svg>
)

export default ArrowLeft
